import React from 'react';

const BS_InputSizing = () => {
    return (
        <div>
            <h1>BS_InputSizing Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_InputSizing;
